/**
 * UI configuration for the professional tier-upgrade dialog.
 *
 * Mirrors the pattern used by user plans (see ``src/app/api/pricing/plans/
 * route.ts::plansData``): the DB ``plans`` table owns the numeric/structural
 * data (prices, annual price, ``is_featured``, ``display_order``,
 * ``overflow_rate_eur``, Stripe IDs). This map owns i18n *key references*
 * under the ``Lawyers.tierUpgrade`` namespace — which localized strings
 * belong to which plan.
 *
 * Looked up by DB tag — ``prof_profile`` (standalone Profil+). If a new
 * professional tier ships without an entry here, the dialog gracefully
 * renders it as "Unknown tier" (caller should add an entry).
 */

export interface ProfessionalTierUiConfig {
  /** DB ``plans.tag`` column value. */
  tag: string;
  /** ``Lawyers.tierUpgrade.<key>`` — plan display name. */
  nameKey: string;
  /** ``Lawyers.tierUpgrade.<key>`` — short tagline under the name. */
  descriptionKey: string;
  /** ``Lawyers.tierUpgrade.<key>[]`` — per-line features. */
  featureKeys: string[];
  /**
   * The ``SubscriptionTier`` enum value this row represents. Used by the
   * dialog to compare against the caller's ``currentTier`` prop so the
   * already-active plan renders as "Current plan" instead of "Select".
   */
  subscriptionTier: 'profile';
}

export const PROFESSIONAL_TIER_UI: Record<string, ProfessionalTierUiConfig> = {
  prof_profile: {
    tag: 'prof_profile',
    subscriptionTier: 'profile',
    nameKey: 'profileName',
    descriptionKey: 'profileDescription',
    featureKeys: [
      'profileFeature1',
      'profileFeature2',
      'profileFeature3',
      'profileFeature4',
    ],
  },
};
